import { render, staticRenderFns } from "./mainReport.vue?vue&type=template&id=3af5f7b2&scoped=true&"
import script from "./mainReport.vue?vue&type=script&lang=js&"
export * from "./mainReport.vue?vue&type=script&lang=js&"
import style0 from "./mainReport.vue?vue&type=style&index=0&id=3af5f7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5f7b2",
  null
  
)

export default component.exports